import { tracking } from '@iwoca/frontend-tracking-library';
import { useNavigate } from 'react-router-dom';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { useTutorials } from './hooks/useTutorials.hook';

type TTour = {
  name: string;
  description: string;
  onClick: () => void;
};

export const usePortalTours = () => {
  const navigate = useNavigate();
  const { triggerNavigationTour } = useTutorials(false);

  const handleNavigationTourClick = () => {
    trackEvent('Navigation');
    triggerNavigationTour();
  };

  const handleCalculatorTourClick = () => {
    trackEvent('Calculator');
    navigate(PATH_NAMES.calculator({ showTour: true }));
  };

  const handleDashboardTourClick = () => {
    trackEvent('Dashboard');
    navigate(PATH_NAMES.home({ showTour: true }));
  };

  const trackEvent = (tour: string) => {
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': 'Start tour',
      category: tour,
    });
  };

  const getTourData = (): TTour[] => [
    {
      name: 'Navigation',
      description:
        'Learn how to move around the Portal, use helpful tools, and create new applications.',
      onClick: () => handleNavigationTourClick(),
    },
    {
      name: 'Dashboard',
      description:
        'Discover how to search, filter, and manage applications efficiently from your dashboard.',
      onClick: () => handleDashboardTourClick(),
    },
    {
      name: 'Calculator',
      description:
        'Quickly calculate and share repayment schedules tailored to your clients.',
      onClick: () => handleCalculatorTourClick(),
    },
  ];

  return {
    tourData: getTourData(),
  };
};
